export default __webpack_public_path__ + "static/media/databiota-logo.742e64bb.svg";